import {diApi} from '@di-shared/api/di';
import {emitEventLog} from '@di-shared/features/analytics';
import useApiError from '@di-shared/features/common/useApiError';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import environmentStore from '@di-shared/features/environment/environmentStore';
import PreventForm from '@shared/PreventForm';
import usePendingHandler from '@shared/usePendingHandler';

export interface SafeDrivingWithdrawBottomSheetEuProps {
  vin: string;
}

export default function ({vin}: SafeDrivingWithdrawBottomSheetEuProps) {
  const {t} = useInferableTranslation();
  const {resolveError} = useApiError();
  const puid = environmentStore.getState().puid;

  const [submitWithdrawSafeDriving] = usePendingHandler(
    async () => {
      await diApi.ubiThirdPartyAgreementsController.updateAgreementsForSeviceDevelop1({
        requestBody: {
          puid,
          vin,
          isAgreed: false,
        },
      });
      window.bottomSheetClose(true);
    },
    async (error) => {
      await resolveError(error);
    }
  );

  return (
    <div className="bottom_sheet">
      <PreventForm onSubmit={submitWithdrawSafeDriving}>
        <div className="bottom_sheet_header">
          <h2
            className="bottom_sheet_title"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T20198')}
          </h2>
          <button
            type="button"
            className="btn btn_ic"
            aria-label={t('T10017')}
            onClick={() => window.bottomSheetClose(false)}
          >
            <span
              className="ic ic_close_20px"
              aria-hidden="true"
            ></span>
          </button>
        </div>
        <div className="bottom_sheet_inner">
          <div className="bottom_sheet_contents">
            <strong className="bottom_sheet_title_sub">{t('T20199')}</strong>
          </div>

          <div className="bottom_sheet_footer bottom_sheet_footer_complex">
            <button
              type="button"
              className="btn btn_large btn_outline"
              onClick={() => window.bottomSheetClose(false)}
            >
              {t('T20119')}
            </button>

            <button
              type="button"
              className="btn btn_large btn_filled"
              onClick={() => {
                emitEventLog({
                  event: 'driving_insight_agreement',
                  interaction_type: 'disagree',
                  click_text: t('T20200'),
                  click_location: 'body',
                });
                submitWithdrawSafeDriving();
              }}
            >
              {t('T20200')}
            </button>
          </div>
        </div>
      </PreventForm>
    </div>
  );
}
